module.exports = __webpack_public_path__ + "img/RedteaSIM 中文首图@2x.89739567.png";